<div [appLoadingAnimation]="!isLoaded" class="cms-page__content">
  <div class="container">
    <div class="row">
      @if (isLoaded) {
        <div [innerHTML]="cmsPageData.attributes.title"></div>
        <div [innerHTML]="cmsPageData.attributes.content"></div>
      }
    </div>
  </div>
</div>
